export const formStyles = () => ({
    paper:{
        padding:'1rem',
        maxWidth: '350px',
        },
    textfield:{
        marginTop:'1rem'
    },
    button:{
marginTop:'1rem'
    }
})